function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2012(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 4.25,
    height: 5.78,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.7083333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.125,
    y: 2.89
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 5.78,
    width: 4.25,
    height: 15.89,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.7083333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.125,
    y: 13.725000000000001
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 21.67,
    width: 4.25,
    height: 35.29,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.85
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.125,
    y: 39.315
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 56.96,
    width: 4.25,
    height: 45.87,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.0625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.125,
    y: 79.895
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 102.83,
    width: 4.25,
    height: 50.23,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.6071428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.125,
    y: 127.945
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 153.06,
    width: 4.25,
    height: 53.42,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.7083333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.125,
    y: 179.77
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 206.48,
    width: 4.25,
    height: 71.14,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.0625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.125,
    y: 242.04999999999998
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 277.62,
    width: 4.25,
    height: 77.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.4722222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.125,
    y: 316.44
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 355.26,
    width: 4.25,
    height: 79.68,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.53125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.125,
    y: 395.1
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 434.93,
    width: 4.25,
    height: 81.54,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.85
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.125,
    y: 475.7
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 516.48,
    width: 4.25,
    height: 88.95,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.7083333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.125,
    y: 560.955
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 605.42,
    width: 4.25,
    height: 94.58,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.7083333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.125,
    y: 652.7099999999999
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 0,
    width: 18.96,
    height: 34.98,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.16
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.73,
    y: 17.49
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.2,
    y: 0,
    width: 20.46,
    height: 34.98,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0460000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.43,
    y: 17.49
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.66,
    y: 0,
    width: 21.16,
    height: 34.98,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.29
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.239999999999995,
    y: 17.49
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.82,
    y: 0,
    width: 21.39,
    height: 34.98,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.67375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.51499999999999,
    y: 17.49
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.21,
    y: 0,
    width: 23.4,
    height: 34.98,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5999999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 97.91,
    y: 17.49
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.61,
    y: 0,
    width: 24.68,
    height: 34.98,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.113333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.95,
    y: 17.49
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.3,
    y: 0,
    width: 25.13,
    height: 34.98,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.2825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 146.865,
    y: 17.49
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.42,
    y: 0,
    width: 26.52,
    height: 34.98,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.315
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.67999999999998,
    y: 17.49
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.94,
    y: 0,
    width: 33.33,
    height: 34.98,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.605,
    y: 17.49
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219.27,
    y: 0,
    width: 33.75,
    height: 34.98,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 236.145,
    y: 17.49
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 253.02,
    y: 0,
    width: 37.62,
    height: 34.98,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8866666666666663
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 271.83,
    y: 17.49
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.64,
    y: 0,
    width: 41.43,
    height: 34.98,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.3725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 311.35499999999996,
    y: 17.49
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.07,
    y: 0,
    width: 42.82,
    height: 34.98,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.829999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 353.48,
    y: 17.49
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 374.89,
    y: 0,
    width: 55.51,
    height: 34.98,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.829999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 402.645,
    y: 17.49
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 430.4,
    y: 0,
    width: 61.2,
    height: 34.98,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.745
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 461,
    y: 17.49
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 491.6,
    y: 0,
    width: 61.74,
    height: 34.98,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.3725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 522.47,
    y: 17.49
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 553.33,
    y: 0,
    width: 66.66,
    height: 34.98,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.829999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 586.6600000000001,
    y: 17.49
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 0,
    width: 80,
    height: 34.98,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.745
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 660,
    y: 17.49
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 34.98,
    width: 66.04,
    height: 43.44,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.239999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.27,
    y: 56.699999999999996
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 78.43,
    width: 66.04,
    height: 50.52,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.613333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.27,
    y: 103.69000000000001
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 128.95,
    width: 66.04,
    height: 51.65,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.33
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.27,
    y: 154.77499999999998
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 180.59,
    width: 66.04,
    height: 57.54,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.59
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.27,
    y: 209.36
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 238.13,
    width: 66.04,
    height: 68.35,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.604000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.27,
    y: 272.305
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 306.48,
    width: 66.04,
    height: 70.29,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.255
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.27,
    y: 341.625
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 376.77,
    width: 66.04,
    height: 71.5,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.402666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.27,
    y: 412.52
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 448.27,
    width: 66.04,
    height: 76.55,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.208000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.27,
    y: 486.54499999999996
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 524.82,
    width: 66.04,
    height: 86.76,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.006666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.27,
    y: 568.2
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 611.58,
    width: 66.04,
    height: 88.42,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.604000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.27,
    y: 655.7900000000001
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.28,
    y: 34.98,
    width: 67.58,
    height: 90.82,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1984615384615385
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 104.07,
    y: 80.38999999999999
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137.86,
    y: 34.98,
    width: 70.89,
    height: 90.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.815
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 173.305,
    y: 80.38999999999999
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.75,
    y: 34.98,
    width: 84.7,
    height: 90.82,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 251.1,
    y: 80.38999999999999
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 293.45,
    y: 34.98,
    width: 89.59,
    height: 90.82,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.931666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 338.245,
    y: 80.38999999999999
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 383.04,
    y: 34.98,
    width: 91.64,
    height: 90.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.705
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 428.86,
    y: 80.38999999999999
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 474.68,
    y: 34.98,
    width: 107.1,
    height: 90.82,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.136666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 528.23,
    y: 80.38999999999999
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 581.77,
    y: 34.98,
    width: 118.23,
    height: 90.82,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.091111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 640.885,
    y: 80.38999999999999
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.28,
    y: 125.81,
    width: 107.55,
    height: 114.26,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.364285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 124.055,
    y: 182.94
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.28,
    y: 240.06,
    width: 107.55,
    height: 126.22,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.273076923076923
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 124.055,
    y: 303.17
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.28,
    y: 366.28,
    width: 107.55,
    height: 153.13,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.9625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 124.055,
    y: 442.84499999999997
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.28,
    y: 519.41,
    width: 107.55,
    height: 180.59,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.754999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 124.055,
    y: 609.7049999999999
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.83,
    y: 125.81,
    width: 166.82,
    height: 131,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.357142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 261.24,
    y: 191.31
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 344.65,
    y: 125.81,
    width: 170.87,
    height: 131,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.714285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 430.085,
    y: 191.31
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 515.52,
    y: 125.81,
    width: 184.48,
    height: 131,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.909090909090908
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 607.76,
    y: 191.31
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.83,
    y: 256.81,
    width: 151.33,
    height: 164.38,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.814444444444447
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 253.495,
    y: 339
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.83,
    y: 421.19,
    width: 151.33,
    height: 278.81,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.221666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 253.495,
    y: 560.595
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.15,
    y: 256.81,
    width: 370.85,
    height: 120.82,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.424444444444443
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 514.575,
    y: 317.22
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.15,
    y: 377.64,
    width: 370.85,
    height: 322.36,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 29.30545454545455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 514.575,
    y: 538.8199999999999
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2012);
export default __webpack_public_path__ + "static/media/2012.84bffeffab0b77de40124be314212bb3.svg";
export { ForwardRef as ReactComponent };